export function timeToMinutes(timeStr) {
    const [hours, minutes] = timeStr.split(':').map(Number)
    return hours * 60 + minutes
}

export function minutesToTime(minutes) {
    if (minutes >= 1439) return '23:59'
    const hours = Math.floor(minutes / 60)
        .toString()
        .padStart(2, '0')
    const mins = (minutes % 60).toString().padStart(2, '0')
    return `${hours}:${mins}`
}

export function toDayKey(ts) {
    const d = new Date(ts)
    const mm = String(d.getMonth() + 1).padStart(2, '0')
    const dd = String(d.getDate()).padStart(2, '0')
    return `${d.getFullYear()}-${mm}-${dd}`
}

/**
 * Extrêmes réels des réservations hors ouverture, par jour.
 *
 * @param {Array<{start: number, end: number}>} source Réservations (timestamps ms).
 * @param {Object<string, {start: number, end: number}>} bounds Bornes d'ouverture
 *        (minutes) par clé de jour ("YYYY-MM-DD").
 * @returns {Object<string, {firstAm: number|null, lastPm: number|null}>}
 *        firstAm = minutes de la réservation la plus matinale commençant avant
 *        l'ouverture ; lastPm = minutes de fin de la réservation la plus tardive
 *        finissant après la fermeture ; null si aucune dans la plage correspondante.
 */
export function computeOutOfHoursExtremes(source, bounds) {
    const extremes = {}
    source.forEach((e) => {
        const key = toDayKey(e.start)
        const b = bounds[key]
        if (!b) return
        const startMin = timeToMinutes(new Date(e.start).toTimeString().slice(0, 5))
        const endMin = timeToMinutes(new Date(e.end).toTimeString().slice(0, 5))
        const ex = extremes[key] || (extremes[key] = { firstAm: null, lastPm: null })
        if (startMin < b.start && (ex.firstAm === null || startMin < ex.firstAm)) ex.firstAm = startMin
        if (endMin > b.end && (ex.lastPm === null || endMin > ex.lastPm)) ex.lastPm = endMin
    })
    return extremes
}
